let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kvImD")).then(() => parcelRequire('ijSaI'));